/**
 * @return {object} breakpoints parameters
 */
function breakpointsDefault() {

	return {
		0: {
			slidesPerView: 1,
			spaceBetween: 32,
		},
	};

}

/**
 * @return {object} breakpoints parameters
 */
function breakpointsLetters() {

	return {
		0: {
			slidesPerView: "auto",
			spaceBetween: 12,
			slidesPerGroupAuto: true,
			centerInsufficientSlides: true,
		},
	};

}

/**
 * @return {object} breakpoints parameters
 */
function breakpointsStudents() {

	return {
		0: {
			slidesPerView: 1.2,
			spaceBetween: 18,
			centeredSlides: true,
		},

		587: {
			slidesPerView: 1.2,
			spaceBetween: 24,
			centeredSlides: true,
		},

		768: {
			slidesPerView: 1.3,
			spaceBetween: 24,
			centeredSlides: true,
			freeMode: true,
		},

		1600: {
			slidesPerView: "auto",
			spaceBetween: 24,
			centeredSlides: true,
			freeMode: true,
		},

		3000: {
			slidesPerView: "auto",
			spaceBetween: 24,
			centeredSlides: true,
			freeMode: true,
		},
	};

}

/**
 * @return {object} breakpoints parameters
 */
function breakpointsNews() {

	return {
		0: {
			slidesPerView: 1.1,
			spaceBetween: 18,
		},

		576: {
			slidesPerView: 1.5,
			spaceBetween: 20,
		},

		768: {
			slidesPerView: 1.8,
			spaceBetween: 20,
		},

		992: {
			slidesPerView: 2.2,
			spaceBetween: 20,
		},

		1140: {
			slidesPerView: 2.5,
			spaceBetween: 20,
		},

		1600: {
			slidesPerView: 2.8,
			spaceBetween: 20,
		},

		1925: {
			slidesPerView: 3,
			spaceBetween: 20,
		},
	};

}

/**
 * Sliders breakpoints
 *
 * @param {string} sliderType
 *
 * @return {object} breakpoints
 */
function getBreakpoins( sliderType ) {

	switch ( sliderType ) {

	case "photo-gallery-slider":
		return breakpointsDefault();
	case "alphabet-slider":
		return breakpointsLetters();
	case "student-stories-slider":
		return breakpointsStudents();
	case "news-slider":
		return breakpointsNews();
	default:
		return breakpointsDefault();

	}

}

/**
 * Sliders arguments
 *
 * @param {object} buttonPrev
 * @param {object} buttonNext
 * @param {string} sliderType
 * @param {boolean} loop
 *
 * @return {object} slider arguments
 */
function sliderArgs( buttonPrev, buttonNext, sliderType, loop = true ) {

	const args = {
		direction: "horizontal",
		loop: loop,
		speed: 1000,
		breakpoints: getBreakpoins( sliderType ),
		observer: true,
		watchOverflow: true,

		navigation: {
			nextEl: buttonNext,
			prevEl: buttonPrev,
		},
		pagination: {
			el: ".swiper-pagination",
			type: "progressbar",
		},
	};
	return args;

}

/**
 * Initialize slider with arguments
 *
 * @param {string} sliderElement
 * @param {object} buttonPrev
 * @param {object} buttonNext
 * @param {string} sliderType
 * @param {boolean} loop
 *
 * @return {object} slider
 */
function initializeSlider(
	sliderElement,
	buttonPrev,
	buttonNext,
	sliderType,
	loop,
) {

	/* eslint-disable */
	if (typeof Swiper !== "undefined") {
		const args = sliderArgs(buttonPrev, buttonNext, sliderType, loop);
		const swiperSlider = new Swiper(
			`${sliderElement} .swiper-container`,
			args,
		);

		return swiperSlider;
	}
	/* eslint-enable */
	return false;

}

/**
 * Set slider settings
 *
 * @param {object} slider
 *
 * @return {object} slider or false
 */
function setSliderSettings( slider ) {

	if ( slider ) {

		const sliderType = slider.getAttribute( "data-slider-type" );
		const buttonPrev = slider.querySelector( ".swiper-button-prev" );
		const buttonNext = slider.querySelector( ".swiper-button-next" );
		const index = Math.floor( Math.random() * 100000 );
		let loop = true;

		if ( sliderType === "alphabet-slider" ) {

			loop = false;

		}

		// add unique class to each slider, so they might work separately
		slider.classList.add( `slider-${index}` );

		// Initialize slider
		const swiperSlider = initializeSlider(
			`.${sliderType}.slider-${index}`,
			buttonPrev,
			buttonNext,
			sliderType,
			loop,
		);

		if ( swiperSlider ) {

			return swiperSlider;

		}

	}

	return false;

}

export default setSliderSettings;
